var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgLeftArrow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2883 6.29324L6.28831 11.2932C6.19727 11.3883 6.1259 11.5005 6.07831 11.6232C5.97829 11.8667 5.97829 12.1398 6.07831 12.3832C6.1259 12.506 6.19727 12.6181 6.28831 12.7132L11.2883 17.7132C11.3815 17.8065 11.4922 17.8804 11.6141 17.9309C11.7359 17.9814 11.8665 18.0073 11.9983 18.0073C12.2646 18.0073 12.52 17.9015 12.7083 17.7132C12.8966 17.5249 13.0024 17.2695 13.0024 17.0032C13.0024 16.7369 12.8966 16.4815 12.7083 16.2932L9.40831 13.0032L16.9983 13.0032C17.2635 13.0032 17.5179 12.8979 17.7054 12.7103C17.893 12.5228 17.9983 12.2685 17.9983 12.0032C17.9983 11.738 17.893 11.4837 17.7054 11.2961C17.5179 11.1086 17.2635 11.0032 16.9983 11.0032L9.40831 11.0032L12.7083 7.71324C12.802 7.62028 12.8764 7.50968 12.9272 7.38782C12.978 7.26596 13.0041 7.13525 13.0041 7.00324C13.0041 6.87123 12.978 6.74052 12.9272 6.61867C12.8764 6.49681 12.802 6.38621 12.7083 6.29324C12.6153 6.19952 12.5047 6.12512 12.3829 6.07435C12.261 6.02358 12.1303 5.99744 11.9983 5.99744C11.8663 5.99744 11.7356 6.02358 11.6137 6.07435C11.4919 6.12512 11.3813 6.19952 11.2883 6.29324Z",
    fill: "#111111"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLeftArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/LeftArrow.a4bf63c7.svg";
export { ForwardRef as ReactComponent };